<template>
  <div :id="id" class="map" data-testid="map" :style="`height: ${height};`" />
</template>

<script>
import mapbox from 'mapbox-gl'

import sitesApi from '@/api/sites'
import mapUtils from '@/utils/mapbox'

export default {
  name: 'ContainerMap',
  data: () => ({
    id: `map-${Math.ceil(Math.random() * 10000)}`,
    map: null,
    site: null,
  }),
  props: {
    container: { type: Object, required: true },
    height: { type: String, default: '485px' },
    extraMarkers: { type: Array, default: () => [] },
  },
  computed: {
    siteBox() {
      return this.site ? mapUtils.siteToBox(this.site) : null
    },
    areaBox() {
      const area = this.site?.areas.find(area => area.uuid == this.container.area_uuid)
      return area ? mapUtils.areaToBox(area) : null
    },
  },
  methods: {
    async getSite() {
      if (!this.container.site_uuid) return

      this.site = await sitesApi.get(this.container.site_uuid)
    },
    initMap() {
      const boxes = [this.siteBox, this.areaBox].filter(box => box)

      this.map = mapUtils.initMap({
        container: this.id,
        center: { lat: this.container.lat, lng: this.container.lng },
        zoom: 14,
        enableFullscreen: true,
        enableNavigationControls: true,
        boxes: boxes,
      })

      this.map.on('load', () => {
        new mapbox.Marker({ color: 'red' }).setLngLat([this.container.lng, this.container.lat]).addTo(this.map)
      })

      this.extraMarkers.forEach(({ lat, lng }) =>
        new mapbox.Marker({ color: '#fab700' }).setLngLat([lng, lat]).addTo(this.map),
      )
    },
  },
  async mounted() {
    await this.getSite()
    this.initMap()
  },
}
</script>

<style scoped>
.map {
  width: 100%;
  margin-bottom: 0;
}
</style>
